module.exports = __webpack_public_path__ + "img/ideation-03-explore-mobile.1c7b4ce1.jpg";